import script from "./PososAnalysisWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./PososAnalysisWidget.vue?vue&type=script&setup=true&lang=ts"

import "./PososAnalysisWidget.vue?vue&type=style&index=0&id=0a865c6c&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a865c6c"]])

export default __exports__